import { SCREENS } from "utils/constants";
import View from "./View";

const routes = [
  {
    path: SCREENS.PRIVATE.ADMIN.CRM_DASHBOARD.path,
    exact: true,
    element: <View />,
  },
];

export default routes;
